export const Booklets = () => {
  const cards = document.querySelectorAll(".booklet-card");

  if (cards.length === 0) return;

  cards.forEach((card) => {
    card.addEventListener("click", () => {
      cards.forEach((card) => {
        card.classList.remove("active");
      });
      card.classList.add("active");

      const cardTop = card.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: cardTop - 16,
        behavior: "smooth",
      });
    });
  });
};
